import { render, staticRenderFns } from "./BillingSwitch.vue?vue&type=template&id=6efb70c9&scoped=true"
import script from "./BillingSwitch.vue?vue&type=script&lang=js"
export * from "./BillingSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb70c9",
  null
  
)

export default component.exports